import { useLingui } from '@lingui/react/macro';
import { switchUserTournament } from 'modules/auth/store/actions';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useCallback, useMemo } from 'react';
import { useMatch } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetOrganizerByIdQuery } from 'modules/organizers/store/organizers-api';
import { useAppDispatch } from 'store/hooks';

export function useOrganizerById() {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const match = useMatch(Pages.ORGANIZERS.VIEW);
  const id = Number(match?.params?.id ?? -1);

  const { data: organizer, isLoading, isError } = useGetOrganizerByIdQuery(id, { skip: id <= 0 });

  const switchOrganizer = useCallback(() => {
    if (organizer?.id) {
      dispatch(switchUserTournament(organizer.id));
    } else {
      toast.error(t`Невозможно переключиться, обновите страницу`);
      console.error('organizer id is undefined', { organizer });
    }
  }, [organizer, dispatch, t]);

  return useMemo(() => ({ organizer, isLoading, isError, id, switchOrganizer }), [organizer, isLoading, isError, id, switchOrganizer]);
}
